import EmptyLayout from "./EmptyLayout";
import ResourceLayout from "./ResourceLayout";
import UserLayout from "./UserLayout";

const LayoutConfig = [
    {
        path: "/not-authorized",
        Layout: EmptyLayout,
    },
    {
        path: '/resources',
        Layout: ResourceLayout
    },
    {
        path: '/my-profile',
        Layout: ResourceLayout
    },
    {
        path: '/job-posting',
        Layout: ResourceLayout
    },
    {
        path: '/add-schedule',
        Layout: ResourceLayout
    },
    {
        path: '/timesheet-defaults',
        Layout: UserLayout
    },
    {
        path: '/timesheet',
        Layout: ResourceLayout
    },
    {
        path: "/my-schedules",
        Layout: ResourceLayout,
    },
    {
        path: "/myProfile",
        Layout: ResourceLayout,
    },
    {
        path: "/resource-dashboard",
        Layout: ResourceLayout,
    },
    {
        path: "/skill-glossary",
        Layout: ResourceLayout,
    },
    {
        path: "/admin/jd-editor",
        Layout: ResourceLayout,
    },
    {
        path: "/admin",
        Layout: UserLayout,
    },
    {
        path: "/projects",
        Layout: UserLayout,
    },
    {
        path: "/demands",
        Layout: UserLayout,
    },
    {
        path: "/requisitions",
        Layout: UserLayout,
    },
    {
        path: "/reportee-list",
        Layout: UserLayout,
    },
    {
        path: "/stock-count",
        Layout: UserLayout,
    },
    {
        path: "/firm-initiatives-employee",
        Layout: ResourceLayout,
    },
    {
        path: "/firm-initiatives-employee?manager=true",
        Layout: UserLayout,
    },
    {
        path: "/firm-initiatives",
        Layout: UserLayout,
    },
    {
        path: "/firm-initiatives?employee=true",
        Layout: ResourceLayout,
    },
    {
        path: "/internal-gig-employee",
        Layout: ResourceLayout,
    },
    {
        path: "/internal-gig-employee?manager=true",
        Layout: UserLayout
    },
    {
        path: "/job-posting?manager=true",
        Layout: UserLayout
    },
    {
        path: "/internal-gig",
        Layout: UserLayout,
    },
    {
        path: '/search-employee',
        Layout: ResourceLayout
    },
    {
        path: '/work-packages-employee',
        Layout: ResourceLayout,
    },
    {
        path: "/",
        Layout: UserLayout,
    },
];

const getLayoutConfig = (path, session, manager = false) => {
    const { user } = session ?? {};
    const isAdminOrRM = ['admin', 'resource_manager', 'guest_rm', 'resource_manager_lead'].some((role) => session?.user?.role?.includes(role));
    const isRecruiterOrHr = ['hrbp', 'recruiter', 'sub_recruiter'].some((role) => session?.user?.role?.includes(role)) && !isAdminOrRM;
    const isPartnerOrManager = ['partner', 'manager'].includes(session?.user?.gradeLevel) && !isAdminOrRM;
    const isResource = session?.user?.gradeLevel === 'resource' && !isPartnerOrManager && !isAdminOrRM;
    const isAuditUser = (session?.user?.function === 'Audit & Assurance' && session?.user?.serviceArea === 'Audit') || session?.user?.isAuditRM || session?.user?.grade === 'DM';
    const isStockCountDelegate = session?.isDelegate && session?.delegateType === 'stockCount';
    if (path === "/login" || path === "/temp-login" || path === "/azure-login") return { Layout: EmptyLayout };
    if (path.startsWith('/requisitions')) {
        return {
            path: "/requisitions",
            Layout: isResource && isRecruiterOrHr ? ResourceLayout : UserLayout,
        }
    }
    if (path.startsWith('/firm-initiatives-employee') && manager) {
        return {
            path: "/firm-initiatives-employee?manager=true",
            Layout: UserLayout,
        }
    }
    if (path.startsWith('/firm-initiatives') && !manager) {
        return {
            path: "/firm-initiatives?employee=true",
            Layout: ResourceLayout,
        }
    }
    if (path.startsWith('/internal-gig-employee') && manager) {
        return {
            path: "/internal-gig-employee?manager=true",
            Layout: UserLayout,
        }
    }
    if (path.startsWith('/job-posting') && manager) {
        return {
            path: "/job-posting?manager=true",
            Layout: UserLayout,
        }
    }
    if (path.startsWith('/stock-count')) {
        return {
            path: "/stock-count",
            Layout: (isResource && isAuditUser || isStockCountDelegate) ? ResourceLayout : UserLayout,
        }
    }
    let config = LayoutConfig.find((configItem) => path.includes(configItem.path))


    if (config) return config;
    else return { Layout: EmptyLayout };
};


export { getLayoutConfig };
